import { call, put, takeEvery } from 'redux-saga/effects';
import { getProfile } from '../../../helpers/profile_helper';
import apiFetch from '../../../fetch';
import { ApolloClient, InMemoryCache, gql } from '@apollo/client';
import { createUploadLink } from 'apollo-upload-client';
// Login Redux States
import { ProfileTypes } from './actionTypes';
import {
  profileSuccess,
  profileError,
  updatePhotoProfileSuccess,
} from './actions';

//Include Both Helper File with needed methods
// import { getFirebaseBackend } from "../../../helpers/firebase_helper"
import { postFakeProfile } from '../../../helpers/fakebackend_helper';
// const fireBaseBackend = getFirebaseBackend()
import * as url from '../../../helpers/url_helper';
function* editProfile({ payload: { user } }: any) {
  try {
    if (process.env.REACT_APP_DEFAULTAUTH === 'firebase') {
      // const response: Promise<any> = yield call(
      //   fireBaseBackend.editProfileAPI,
      //   user.username,
      //   user.idx
      // )
      // yield put(profileSuccess(response))
    } else if (process.env.REACT_APP_DEFAULTAUTH === 'jwt') {
      // const response: Promise<any> = yield call(postJwtProfile, "/post-jwt-profile",  {
      //   username: user.username,
      //   idx: user.idx,
      // })
      // yield put(profileSuccess(response))
    } else if (process.env.REACT_APP_DEFAULTAUTH === 'fake') {
      const response: Promise<any> = yield call(postFakeProfile, {
        username: user.username,
        idx: user.idx,
      });
      yield put(profileSuccess(response));
    }
  } catch (error) {
    yield put(profileError(error));
  }
}

export function* watchProfile({ payload: { user } }: any) {
  try {
    const response: Promise<any> = yield call(getProfile, user);
    yield put(profileSuccess(response));
  } catch (error) {
    yield put(profileError(error));
  }
  yield takeEvery(ProfileTypes.EDIT_PROFILE, editProfile);
}

/*function* ProfileSaga() {
  yield all([fork(watchProfile)])
}*/

function* getData({ payload: { user } }: any): any {
  const path = url.API_URL;
  const query = `query{
    GetUserProfileById(Users: {
        id: ${user.id}
    }){
      id
      NETWORK_ID
      ACCOUNT_NUMBER
      USUARIO_NOMBRE
      USUARIO_APELLIDO
      USUARIO_CORREO
      USUARIO_TELEFONO
      USUARIO_LOGIN
      CELULAR
      USUARIO_SEXO
      URL_FOTO_PERFIL
      CEDULA
    }
  }`;

  const opts = {
    authRequired: false,
    body: {
      query,
      //variables: {user: userApi},
    },
    method: 'POST',
  };

  const casing = 'underscore';
  const resp = yield call(apiFetch, path, opts);
  const responseBody = resp.body.data.GetUserProfileById;

  if (resp?.status === 200) {
    yield put(profileSuccess(responseBody));
  } else {
    yield put(profileError(responseBody));
  }
}

function* updateImageUser({ payload }: any): any {
  const path = url.API_URL;
  const { file, id, nameField } = payload;
  try {
    const client = new ApolloClient({
      link: createUploadLink({ uri: url.API_URL }),
      cache: new InMemoryCache(),
    });
    const query = gql`
      mutation addPhotoProfile(
        $file: Upload!
        $id: String
        $nameField: String
      ) {
        addPhotoProfile(file: $file, id: $id, nameField: $nameField) {
          success
          url
        }
      }
    `;
    const mutationPromise = client.mutate({
      mutation: query,
      variables: { file, id: String(id), nameField },
    });
    const response = yield call(() => mutationPromise);
    if (response?.data?.addPhotoProfile?.success) {
      yield put(updatePhotoProfileSuccess(response.data.addPhotoProfile.url));
    }
  } catch (error) {
    console.log(error);
  }
}
function* ProfileSaga() {
  yield takeEvery(ProfileTypes.VIEW_PROFILE, getData);
  yield takeEvery(ProfileTypes.UPDATE_PROFILE_PICTURE, updateImageUser);
}

export default ProfileSaga;
